import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './Policies.css';

function ShippingPolicy() {
  return (
    <Container className="policy-page py-5">
      <h1 className="text-center mb-5">Kargo ve Teslimat Politikası</h1>
      
      <Row className="g-4">
        <Col lg={8} className="mx-auto">
          <Card className="policy-card">
            <Card.Body>
              <section className="mb-5">
                <h4>Kargo Süreci ve Teslimat Süreleri</h4>
                <ul className="policy-list">
                  <li>Siparişleriniz, ödeme onayından sonra 1-2 iş günü içerisinde hazırlanır.</li>
                  <li>Özel tasarım ürünleriniz için üretim süresi 2-3 iş günüdür.</li>
                  <li>Kargo teslimat süresi ortalama 2-4 iş günüdür.</li>
                  <li>Kargo takip numaranız, ürün kargoya verildiğinde SMS ve e-posta yoluyla tarafınıza iletilir.</li>
                </ul>
              </section>

              <section className="mb-5">
                <h4>Kargo Firmaları ve Ücretlendirme</h4>
                <p>
                  Anlaşmalı olduğumuz kargo firmaları aracılığıyla Türkiye'nin her yerine gönderim yapılmaktadır:
                </p>
                <ul className="policy-list">
                  <li>HEPSI JET</li>
                  <li>ARAS KARGO</li>
                  <li>PTT Kargo</li>
                </ul>
                <p>
                  300 TL ve üzeri tüm siparişlerinizde kargo ücretsizdir. 300 TL altındaki siparişlerde kargo ücreti 50.00 TL'dir.
                </p>
              </section>

              <section className="mb-5">
                <h4>Teslimat Bilgileri</h4>
                <ul className="policy-list">
                  <li>Teslimatlar sadece Türkiye içerisine yapılmaktadır.</li>
                  <li>Kargo teslimatları hafta içi 09:00-18:00 saatleri arasında yapılır.</li>
                  <li>Teslimat adresi değişikliği için müşteri hizmetlerimizle iletişime geçebilirsiniz.</li>
                  <li>Kargo teslimi sırasında ürünü kontrol etme hakkına sahipsiniz.</li>
                  <li>Kargo firması, adresinize 3 kez teslimat denemesi yapar.</li>
                </ul>
              </section>

              <section className="mb-5">
                <h4>Kargo Takibi</h4>
                <p>
                  Siparişiniz kargoya verildikten sonra size SMS ve e-posta ile bilgilendirme yapılacaktır. 
                  Kargo takip numaranız ile gönderinizi anlaşmalı kargo firmalarının web sitelerinden veya 
                  hesabınızdan takip edebilirsiniz.
                </p>
              </section>

              <section>
                <h4>Önemli Bilgiler</h4>
                <ul className="policy-list">
                  <li>Teslimat sırasında kimlik gösterilmesi zorunludur.</li>
                  <li>Hasarlı veya yanlış gönderilen ürünler için iade/değişim ücreti firmamıza aittir.</li>
                  <li>Kargo firmasından kaynaklanan gecikmelerden firmamız sorumlu değildir.</li>
                  <li>Bayram ve resmi tatil dönemlerinde teslimat süreleri uzayabilir.</li>
                </ul>
                <p className="mt-4">
                  Kargo ve teslimat ile ilgili sorularınız için bize mr.browncases@gmail.com adresinden veya 
                  +90 535 873 46 92 numaralı telefondan ulaşabilirsiniz.
                </p>
              </section>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default ShippingPolicy;